import PopupService from 'src/utils/PopupService';
import i18n from 'src/lang/i18n';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import get from 'lodash/get';

dayjs.extend(customParseFormat);

export const goBack = () => {
};

export const goBackCustom = (history) => {
  history.goBack();
};

export const isValidDate = (dateStr: string, format: string): boolean => {
  return dayjs(dateStr, format).format(format) === dateStr;
};

export const featureInDevelopment = () => {
  PopupService.instance.current.open({
    visible: true,
    content: i18n.t('feature_in_development'),
    onOk: () => {
      PopupService.instance.current.close();
    },
  });
};

export const getErrorCode = (response: any): string => {
  return (
    get(response, 'data.errorCode', '') ||
    get(response, 'data.messages[0].code', '') ||
    get(response, 'response.data.messages[0].code', '') ||
    'MSG03'
  );
};

export const getErrorMessage = (response: any): string => {
  return (
    get(response, 'data.messages[0].message', '') ||
    get(response, 'response.data.messages[0].message', '')
  );
};

export const callToPhoneNumber = (phoneNumber: string): void => {
  const linkElement = document.createElement('a');
  linkElement.setAttribute('href', `tel:${phoneNumber}`);
  linkElement.click();
};

export const scrollToTop = () => {
  document.documentElement.scrollTo(0, 0);
};

export const getLoginTokenAtUrl = () => {
  return new URLSearchParams(window.location.search).get('loginToken');
};

export const getCancerLink = () => {
  const isNotDevEnvironment =
    window.location.hostname !== 'landing-page-test.mbageas.org';
  const cancerUrl = isNotDevEnvironment
    ? 'https://cancer.mbageas.org'
    : 'https://cancer-test.mbageas.org';
  return cancerUrl;
};

export const goToExternalPage = (page: string) => {
  window.location.href = page;
};

// Export phone number formatter functions
export { formatTextWithPhoneNumbers, formatTextWithPhoneNumbersAsHTML } from './phoneNumberFormatter';

